import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinpune() {



  const cardData =
  {
    keyword: 'Bus On Rent in Pune',
    heading: 'Amruta Travels: Bus On Rent in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers reliable and affordable Bus on Rent in Pune, catering to all types of travel needs — from corporate tours and school trips to weddings, pilgrimages, and family outings. Our diverse fleet includes AC and Non-AC buses, ranging from 17-seater minibuses to 53-seater luxury coaches, ensuring comfort and convenience for groups of any size. Each bus is equipped with push-back seats, powerful air conditioning, ample legroom, and spacious luggage compartments, making every journey pleasant and worry-free. Operated by professional and courteous chauffeurs, our services guarantee safety, punctuality, and a premium travel experience. Whether it’s a short city ride or an outstation trip to Mumbai, Shirdi, Mahabaleshwar, or Goa, Amruta Travels’ Bus Rental in Pune stands out as the preferred choice for comfortable, affordable, and dependable group transportation.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
    {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
    {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
   {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



     "services": [
    {
      "name": "Bus On Rent in Pune",
      "description": "Bus On Rent in Pune offers a wide range of buses suitable for group travel, corporate outings, school trips, and social events. With a focus on safety, comfort, and punctuality, these buses are maintained regularly and come with professional drivers familiar with Pune’s routes. Whether for city travel or longer journeys, this service provides reliable transportation options tailored to various group sizes and needs."
    },
    {
      "name": "Bus Hire Pune",
      "description": "Bus Hire Pune specializes in renting buses of different capacities for local and outstation travel. Ideal for families, schools, corporate groups, and tourists, this service ensures comfortable seating, clean vehicles, and timely pickups. Experienced drivers prioritize safety and smooth rides, making group transportation in Pune seamless and stress-free."
    },
    {
      "name": "Bus Rental Pune",
      "description": "Bus Rental Pune delivers flexible and affordable rental options for buses across the city and surrounding areas. Customers can choose from a variety of buses including AC, non-AC, and luxury models to suit their budget and travel requirements. The service emphasizes transparency in pricing, vehicle hygiene, and excellent customer support throughout the rental period."
    },
    {
      "name": "AC Bus on Rent Pune",
      "description": "AC Bus on Rent Pune provides air-conditioned buses that ensure a comfortable and cool journey, especially suitable for Pune’s warm climate and long-distance travel. Equipped with modern AC systems and comfortable interiors, these buses are perfect for corporate events, weddings, and tourist groups seeking premium travel experiences with punctual and courteous drivers."
    },
    {
      "name": "Non AC Bus on Rent Pune",
      "description": "Non AC Bus on Rent Pune offers budget-friendly transportation options without compromising on cleanliness or safety. These non-AC buses are well-maintained and ideal for short city trips, school outings, and economical group travel. Professional drivers ensure timely service and smooth rides, making this option popular among cost-conscious travelers."
    },
    {
      "name": "Luxury Bus Hire Pune",
      "description": "Luxury Bus Hire Pune features buses with upscale interiors, premium seating, and advanced amenities such as entertainment systems, Wi-Fi, and charging ports. These buses cater to high-profile corporate events, weddings, and VIP group outings. Skilled chauffeurs provide attentive and discreet service, guaranteeing a sophisticated and comfortable travel experience."
    },
    {
      "name": "Mini Bus on Rent Pune",
      "description": "Mini Bus on Rent Pune specializes in smaller buses that are ideal for compact groups, city tours, and short trips. These mini buses offer agility in navigating Pune’s busy streets while providing comfortable seating and sufficient luggage space. The service is perfect for families, small corporate groups, and local sightseeing with professional drivers ensuring safety and convenience."
    },
    {
      "name": "Tourist Bus Rental Pune",
      "description": "Tourist Bus Rental Pune caters to travelers seeking comfortable and reliable transportation for sightseeing tours and excursions around Pune and nearby attractions. These buses come equipped with spacious seating, ample luggage capacity, and knowledgeable drivers who often double as local guides. Customized travel packages ensure a memorable and enjoyable tourist experience."
    },
    {
      "name": "Volvo Bus Hire Pune",
      "description": "Volvo Bus Hire Pune offers premium Volvo buses known for their smooth ride, advanced safety features, and superior comfort. Suitable for long-distance travel, corporate trips, and luxury tours, these buses provide spacious seating, modern amenities, and professional drivers focused on delivering an excellent travel experience."
    },
    {
      "name": "Corporate Bus Hire Pune",
      "description": "Corporate Bus Hire Pune provides tailored transportation solutions for businesses requiring reliable and comfortable bus services for employees, clients, and events. These buses are equipped with modern amenities and driven by courteous chauffeurs who understand the importance of professionalism and punctuality in corporate travel."
    },
    {
      "name": "Wedding Bus Hire Pune",
      "description": "Wedding Bus Hire Pune specializes in elegant and spacious buses designed for wedding parties and guest transportation. This service includes options for vehicle decoration, timely pickups and drop-offs, and attentive drivers to ensure smooth logistics and a luxurious travel experience that complements your special day."
    },
    {
      "name": "School Bus Rental Pune",
      "description": "School Bus Rental Pune offers safe, reliable, and comfortable buses tailored for school transportation needs including daily commutes, field trips, and special events. These buses are maintained to high safety standards, driven by experienced drivers trained to handle student groups, and offer flexible scheduling to meet school requirements."
    },
    {
      "name": "Affordable Bus Hire Pune",
      "description": "Affordable Bus Hire Pune provides cost-effective group transportation solutions without compromising on safety or service quality. This service is popular among schools, small businesses, families, and social groups looking for budget-friendly rental options. Transparent pricing and well-maintained vehicles ensure a hassle-free booking experience."
    },
    {
      "name": "Bus Booking Online Pune",
      "description": "Bus Booking Online Pune offers a convenient digital platform for reserving buses with instant confirmation, multiple payment methods, and customizable itineraries. This user-friendly service allows customers to book local and outstation buses easily, supported by 24/7 customer care for smooth travel planning."
    },
    {
      "name": "Bus Hire near Me Pune",
      "description": "Bus Hire near Me Pune ensures quick access to buses in your vicinity for immediate or scheduled group travel. With a focus on rapid response, professional drivers, and well-maintained vehicles, this service makes group transportation accessible and hassle-free throughout Pune city."
    },
    {
      "name": "Full Bus Booking Pune",
      "description": "Full Bus Booking Pune caters to customers seeking exclusive bus rentals for entire groups or organizations. Whether for corporate events, large family outings, or school trips, this service offers flexible booking options, well-maintained buses, and professional drivers to provide a personalized and comfortable travel experience."
    },
    {
      "name": "Bus for Outstation Pune",
      "description": "Bus for Outstation Pune specializes in long-distance bus rentals for group travel beyond Pune to nearby cities, tourist destinations, and business locations. These buses are designed for comfort and safety over extended journeys, with spacious seating, ample luggage space, and experienced drivers ensuring timely and smooth trips."
    },
    {
      "name": "Bus Hire Pune City",
      "description": "Bus Hire Pune City focuses on providing efficient and reliable bus rental services within Pune city limits. Suitable for daily commutes, local tours, corporate events, and social functions, this service offers clean vehicles, professional drivers, and flexible rental durations to meet the dynamic transportation needs of Pune’s urban population."
    }
  ],
  "tableData": [
    ["Bus On Rent in Pune", "Bus Hire Pune"],
    ["Bus Rental Pune", "AC Bus on Rent Pune"],
    ["Non AC Bus on Rent Pune", "Luxury Bus Hire Pune"],
    ["Mini Bus on Rent Pune", "Tourist Bus Rental Pune"],
    ["Volvo Bus Hire Pune", "Corporate Bus Hire Pune"],
    ["Wedding Bus Hire Pune", "School Bus Rental Pune"],
    ["Affordable Bus Hire Pune", "Bus Booking Online Pune"],
    ["Bus Hire near Me Pune", "Full Bus Booking Pune"],
    ["Bus for Outstation Pune", "Bus Hire Pune City"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers a wide range of buses on rent in Pune, suitable for all group sizes and travel purposes including weddings, tours, corporate events, and more."
  },
  {
    "WhyChooseheading": "Multiple Seating Capacity Options",
    "WhyChoosedescription": "Choose from various bus sizes—17, 35, 45, 50, and 53 seaters—depending on your group size and travel requirements."
  },
  {
    "WhyChooseheading": "Clean, Comfortable, and Well-Maintained Fleet",
    "WhyChoosedescription": "Our buses are regularly serviced, sanitized, and equipped with modern amenities for a safe and pleasant journey."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We provide clear and competitive pricing with no hidden charges—what you see is what you pay."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Whether you need a bus for a few hours, a full day, or multiple days, we offer customizable packages to suit your travel plans."
  },
  {
    "WhyChooseheading": "Experienced and Reliable Drivers",
    "WhyChoosedescription": "Our professional drivers are trained to ensure your trip is safe, timely, and comfortable."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "We offer round-the-clock assistance to help with bookings, updates, and travel coordination at any time."
  },
  {
    "WhyChooseheading": "Quick and Hassle-Free Booking",
    "WhyChoosedescription": "Easily book your bus online or over the phone, with prompt service and vehicle availability throughout Pune."
  }
]


























  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer bus rental services in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides buses on rent in Pune, suitable for all group sizes and travel needs.',
  },
  {
    question: 'How can I book a bus in Pune with Amruta Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24×7 customer support team in Pune.',
  },
  {
    question: 'What types of buses are available for rent in Pune?',
    answer: 'We offer a range of buses including mini buses, 17 seater Urbania, 35 seater, 45 seater, 50 seater, and 53 seater buses to suit your requirements.',
  },
  {
    question: 'Are the drivers trained and experienced for bus rentals in Pune?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in safely driving buses of various sizes in Pune.',
  },
  {
    question: 'Can buses be rented for weddings, corporate events, tours, and airport transfers in Pune?',
    answer: 'Absolutely. Our buses are ideal for weddings, corporate outings, sightseeing tours, airport transfers, and other group travel needs in Pune.',
  },
  {
    question: 'Is the bus hire service available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24×7 bus rental services in Pune to accommodate your schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for bus hires?',
    answer: 'All buses are thoroughly sanitized before every trip, and drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'What are the payment options for bus rental in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the bus rental period in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you anytime during your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Desai',
    feedback: 'Amruta Travels provided us with a clean and comfortable bus in Pune. The driver was punctual and professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rekha Sharma',
    feedback: 'Excellent bus rental experience with Amruta Travels Pune. The entire process was smooth and hassle-free.',
    rating: 5,
  },
];
































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/12.jpg",
  "description": "Book Bus On Rent in Pune with Amruta Travels Pvt. Ltd. offering AC, Non-AC, Luxury, Mini, and Volvo buses for corporate events, weddings, school trips, and outstation travel. Affordable and reliable bus rental services in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "17500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/bus-on-rent-in-pune"
  }
};





  return (
    <div>
<Helmet>
  <title>Bus On Rent in Pune | AC, Luxury & Mini Bus Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book Bus On Rent in Pune with Amruta Travels Pvt. Ltd. Choose from AC, Non-AC, Luxury, Mini, and Volvo buses for corporate, wedding, school, and outstation trips. Affordable and trusted bus rental service in Pune."
  />
  <meta
    name="keywords"
    content="Bus On Rent in Pune, Bus Hire Pune, Bus Rental Pune, AC Bus on Rent Pune, Non AC Bus on Rent Pune, Luxury Bus Hire Pune, Mini Bus on Rent Pune, Tourist Bus Rental Pune, Volvo Bus Hire Pune, Corporate Bus Hire Pune, Wedding Bus Hire Pune, School Bus Rental Pune, Affordable Bus Hire Pune, Bus Booking Online Pune, Bus Hire near Me Pune, Full Bus Booking Pune, Bus for Outstation Pune, Bus Hire Pune City"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinpune;